import styled from "../../theme";

export const Link = styled.a`
  color: ${(props) => props.theme.colors.primary};
  cursor: pointer;
  :hover {
    text-decoration: underline;
  }
`;
